const invoice_xml = {
  title: 'Fatture XML',
  placeholder: 'Sezione in costruzione. Funzionalità in arrivo.',
  search_placeholder: 'Cerca fatture...',
  filter_placeholder: 'Filtra',
  filter_search_label: 'Cerca',
  no_data: 'Nessuna fattura trovata',
  col_number: 'Numero',
  col_date: 'Data',
  col_name: 'Denominazione',
  col_total: 'Importo totale',
  col_type: 'Tipo documento',
  col_ddt: 'Numero DDT',
  prod_col_line: 'Numero Linea',
  prod_col_code: 'Articolo',
  prod_col_description: 'Descrizione',
  prod_col_price: 'Prezzo Unitario',
  prod_col_quantity: 'Quantità',
  prod_col_total: 'Prezzo Totale',
  prod_col_ddt: 'Numero DDT',
  prod_col_invoice_date: 'Data Fatturazione',
  products_search_placeholder: 'Cerca prodotti...',
  products_no_data: 'Nessun prodotto trovato',
  products_section_title: 'Prodotti fattura {number}',
  invoices_section_title: 'Elenco fatture',
  ddts_section_title: 'DDT fattura {number}',
  ddts_search_placeholder: 'Cerca DDT...',
  ddts_no_data: 'Nessun DDT trovato',
  ddt_col_code: 'Codice DDT',
  ddt_col_date: 'Data DDT',
}

export default invoice_xml